var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path5, _path6, _path7, _path8, _path9, _rect10, _rect11, _rect12, _path10, _path11, _polygon, _path12, _polygon2, _path13, _circle, _path14, _path15, _path16, _path17, _path18, _path19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaterUsePrimary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 892.0435,
    height: 637,
    viewBox: "0 0 892.0435 637",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M814.64862,767.49315l-.9015-.338c-.1981-.07464-19.91455-7.62863-29.15058-24.75712-9.23645-17.12926-4.71379-37.75295-4.667-37.95884l.21286-.93923.90109.338c.1981.07465,19.91414,7.62863,29.15058,24.75712,9.23645,17.12926,4.71379,37.75295,4.667,37.95884Zm-28.5731-25.89235c7.80873,14.48219,23.38929,21.9058,27.33692,23.60052.75057-4.231,3.10439-21.34062-4.69738-35.80887-7.80094-14.4666-23.38765-21.9017-27.33692-23.60051C780.62716,710.02539,778.27416,727.13333,786.07552,741.6008Z",
    transform: "translate(-153.97825 -131.5)",
    fill: "#e5e5e5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M791.655,736.38967c16.59838,9.98613,22.991,29.82137,22.991,29.82137s-20.51874,3.64449-37.11712-6.34165-22.991-29.82137-22.991-29.82137S775.05661,726.40353,791.655,736.38967Z",
    transform: "translate(-153.97825 -131.5)",
    fill: "#e5e5e5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1046.02175,415.5H545.79958v-284h500.22217Z",
    transform: "translate(-153.97825 -131.5)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1046.02175,415.5H545.79958v-284h500.22217Zm-494.22217-6h488.22217v-272H551.79958Z",
    transform: "translate(-153.97825 -131.5)",
    fill: "#e5e5e5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 480.90613,
    y: 91.83587,
    width: 322.05254,
    height: 8.05267,
    fill: "#3f3d56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 480.90613,
    y: 137.83587,
    width: 322.05254,
    height: 8.05267,
    fill: "#3f3d56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 480.90613,
    y: 183.83587,
    width: 322.05254,
    height: 8.05267,
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 521.22441,
    y: 79.8622,
    width: 14,
    height: 32,
    fill: "#2a5050"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 620.22441,
    y: 126.1378,
    width: 14,
    height: 32,
    fill: "#2a5050"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 744.22441,
    y: 172.1378,
    width: 14,
    height: 32,
    fill: "#2a5050"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 394.90613,
    y: 326.83587,
    width: 194.05254,
    height: 8.05267,
    fill: "#cbcbcb"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 394.90613,
    y: 353.83587,
    width: 194.05254,
    height: 8.05267,
    fill: "#cbcbcb"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 394.90613,
    y: 380.83587,
    width: 95.05254,
    height: 8.05267,
    fill: "#cbcbcb"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M735.20266,571.5h-59v-59h59Z",
    transform: "translate(-153.97825 -131.5)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M735.20266,571.5h-59v-59h59Zm-57-2h55v-55h-55Z",
    transform: "translate(-153.97825 -131.5)",
    fill: "#cbcbcb"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1043.20266,571.5h-59v-59h59Z",
    transform: "translate(-153.97825 -131.5)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1043.20266,571.5h-59v-59h59Zm-57-2h55v-55h-55Z",
    transform: "translate(-153.97825 -131.5)",
    fill: "#e5e5e5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "bc2b8cae-94aa-4e1c-8c4f-fe8a4409e542-3001",
    "data-name": "Path 202",
    d: "M703.07562,550.69484l-7.075-9.1,4.114-3.2,3.35,4.307,11.318-11.946,3.785,3.585Z",
    transform: "translate(-153.97825 -131.5)",
    fill: "#2a5050"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 694.90613,
    y: 326.83587,
    width: 194.05254,
    height: 8.05267,
    fill: "#e5e5e5"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 694.90613,
    y: 353.83587,
    width: 194.05254,
    height: 8.05267,
    fill: "#e5e5e5"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 694.90613,
    y: 380.83587,
    width: 95.05254,
    height: 8.05267,
    fill: "#e5e5e5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M340.52822,541.4186a9.02394,9.02394,0,0,0,1.50022-12.74654,9.27792,9.27792,0,0,0-1.02634-1.09049l-2.68891-118.36932-19.40737,3.46523,8.76581,115.87841a9.04061,9.04061,0,0,0,.02025,11.23282A9.20279,9.20279,0,0,0,340.52822,541.4186Z",
    transform: "translate(-153.97825 -131.5)",
    fill: "#ffb7b7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M335.17,387.36672c-.235-.05685-.47168-.10744-.71183-.15294A13.84212,13.84212,0,0,0,318.12194,399.549l-.54034,5.86732,2.12011,63.31664,20.65229-.11418,4.37042-52.93765.98816-13.87969A13.838,13.838,0,0,0,335.17,387.36672Z",
    transform: "translate(-153.97825 -131.5)",
    fill: "#cbcbcb"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "264.245 624.885 275.689 624.884 281.132 580.747 264.243 580.747 264.245 624.885",
    fill: "#ffb7b7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M415.30475,752.64872l22.53557-.00091h.00091a14.3622,14.3622,0,0,1,14.36143,14.3612v.46669l-36.89723.00137Z",
    transform: "translate(-153.97825 -131.5)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.497 611.492 97.854 616.357 121.547 578.721 106.26 571.542 87.497 611.492",
    fill: "#ffb7b7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M240.4213,738.36972l20.39786,9.58014.00083.00039a14.3622,14.3622,0,0,1,6.89323,19.1044l-.19842.42242L234.11767,751.7915Z",
    transform: "translate(-153.97825 -131.5)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 338.85542,
    cy: 351.6509,
    r: 26.73494,
    transform: "translate(-286.21581 348.80842) rotate(-61.33683)",
    fill: "#ffb8b8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M346.58141,390.46843l-24.31433-7.15127-16.3049,41.19133,30.3214,62.64515.5721,11.156s-21.33119,26.13608-23.17013,64.36145L305.67613,584.697l-9.43968,20.88172-57.023,116.68157,23.46073,14.79831L366.26235,564.893l50.89172,177.94059,21.34328,1.19516-19.89954-224.9744-22.017-44.39491-9.74522-22.017s11.05317-24.11558-10.34514-35.41561Z",
    transform: "translate(-153.97825 -131.5)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M367.34328,322.29877c-6.60986-5.44214-17.34033-4.92444-24.751-.11072a24.07124,24.07124,0,0,0-28.2627,2.99518c-7.38818,7.00732-9.32129,19.10339-5.38037,28.51947a31.42971,31.42971,0,0,1-4.74365,29.09936c7.166.41809,14.33154.83625,21.51465.957a25.67458,25.67458,0,0,0,4.5874-3.70044c2.85693,3.07563,5.73437,4.65613,6.30762,4.56055a94.97556,94.97556,0,0,1,23.1372-.0791c-3.64648-11.59485-7.293-23.1897-11.7666-33.45532,7.53369,4.06891,17.96387,1.49664,22.74219-5.6084C375.50588,338.37128,373.95364,327.74091,367.34328,322.29877Z",
    transform: "translate(-153.97825 -131.5)",
    fill: "#2f2e41"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M396.846,542.13269a9.02394,9.02394,0,0,0-1.53913-12.74191,9.28113,9.28113,0,0,0-1.254-.81857l-30.44752-114.418L345.557,422.08585l35.7683,110.568a9.0406,9.0406,0,0,0,2.661,10.91308A9.20279,9.20279,0,0,0,396.846,542.13269Z",
    transform: "translate(-153.97825 -131.5)",
    fill: "#ffb7b7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M355.4134,393.66036c-.24177,0-.48372.00649-.72783.01874A13.8421,13.8421,0,0,0,341.708,409.50979l.85448,5.82986,16.94929,61.04272,20.04635-4.96727-8.20018-52.481-2.30329-13.72287A13.838,13.838,0,0,0,355.4134,393.66036Z",
    transform: "translate(-153.97825 -131.5)",
    fill: "#cbcbcb"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M535.97825,768.5h-381a1,1,0,0,1,0-2h381a1,1,0,1,1,0,2Z",
    transform: "translate(-153.97825 -131.5)",
    fill: "#cbcbcb"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M869.97825,768.5h-148a1,1,0,0,1,0-2h148a1,1,0,1,1,0,2Z",
    transform: "translate(-153.97825 -131.5)",
    fill: "#cbcbcb"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterUsePrimary);
export default __webpack_public_path__ + "static/media/water-use-primary.531d6957f53a7e40bad2205d21a3a76e.svg";
export { ForwardRef as ReactComponent };